import React, { useEffect, useState } from 'react';

interface CountdownProps {
  endTime: number;
  startTime: number;
}

const Countdown: React.FC<CountdownProps> = ({ startTime, endTime }) => {
  const [timeRemaining, setTimeRemaining] = useState<string>('');
  const [color, setColor] = useState('text-green-600');

  useEffect(() => {
    const intervalId = setInterval(() => {
      const currentTime = Date.now() / 1000;
      const remainingTime = endTime - currentTime;

      const totalDuration = endTime - startTime;
      const elapsedTime = currentTime - startTime;
      const percentage = Math.min(100, (elapsedTime / totalDuration) * 100);

      //time running out
      if (percentage > 75) {
        setColor('text-red-500');
      }

      // ended
      if (remainingTime <= 0) {
        setTimeRemaining('00:00:00');
        clearInterval(intervalId);
      } else {
        // active
        const hours = Math.floor(remainingTime / 3600);
        const minutes = Math.floor((remainingTime / 60) % 60);
        const seconds = Math.floor(remainingTime % 60);
        const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes
          .toString()
          .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        setTimeRemaining(formattedTime);
      }
    }, 1000);

    return () => {
      clearInterval(intervalId);
    };
  }, [endTime, startTime]);

  return <span className={color}>{timeRemaining}</span>;
};

export default Countdown;
